'use strict';
define('elements/shop',['jquery'], function($) {
    $(document).ready(function () {

        var opticsFieldset = $('.powermail_fieldset_35'),
            equipmentFieldset = $('.powermail_fieldset_36'),
            giftcardFieldset = $('.powermail_fieldset_37');

        $('input[name="tx_powermail_pi1[field][produkttyp]"]').change(function() {
            var currentFieldSet;
            [opticsFieldset, equipmentFieldset, giftcardFieldset].forEach(function(fieldset) {
                fieldset.removeClass('is-visible');
                $(':input', fieldset).attr('disabled', true);
            });

            switch ($(this).attr('id')) {
                case 'powermail_field_produkttyp_2':
                    currentFieldSet = equipmentFieldset;
                    break;
                case 'powermail_field_produkttyp_3':
                    currentFieldSet = giftcardFieldset;
                    break;
                default:
                    currentFieldSet = opticsFieldset;
                    break;
            }
            currentFieldSet.addClass('is-visible');
            $(':input', currentFieldSet).removeAttr('disabled');
        }).filter(':checked').trigger('change');
    });
});

